import React, { Fragment, useEffect, useState } from 'react';
import {
  Accordion,
  Button,
  Card,
  Col,
  Form,
  InputGroup,
  Row,
} from 'react-bootstrap';
// import Modal from 'react-modal';
import Modal from 'react-bootstrap/Modal';
import { toast } from 'react-toastify';
import UserHttp from '../services/profile.service';
import { userStore } from '../../../store/UserStore';
import styled from '../styles.css';
import CreateSubAccount from './create-sub-account';
import UpdateAddress from './update-address';
import UpdateNewAddress from './update-newaddress';

interface PropsType {
  user: any;
  customer: any;
}

const NewAccountDetails: React.FC<PropsType> = ({ user, customer }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [OpenModal, setOpenModal] = useState(false);
  const [editAddress, setEditAddress] = useState(false);
  const [setCustomer] = userStore((state: any) => [state.setCustomer]);
  const [billingAddress, setBillingAddress] = useState<any>({
    address1: '',
    address2: '',
    pinCode: '',
    city: '',
    state: '',
  });
  const [shippingAddress, setShippingAddress] = useState<any>({
    address1: '',
    address2: '',
    pinCode: '',
    city: '',
    state: '',
  });
  const [accountDetails, setAccount] = useState<any>({
    displayName: '',
    kyc: {
      gstin: {
        value: '',
      },
    },
  });
  const [isShow, setIsShow] = useState(false);

  useEffect(() => {
    setShippingAddress({
      address1: '',
      address2: '',
      pinCode: '',
      city: '',
      state: '',
    });
    setBillingAddress({
      address1: '',
      address2: '',
      pinCode: '',
      city: '',
      state: '',
    });
    setAccount({
      displayName: '',
      kyc: {
        gstin: {
          value: '',
        },
      },
    });
  }, [isOpen]);

  function closeModal() {
    setIsOpen(false);
  }

  function openModal() {
    setIsOpen(true);
  }

  const save = async () => {
    var data = {
      customerId: customer.customerId,
      displayName: accountDetails.displayName,
      kyc: accountDetails.kyc,
      shippingAddress: shippingAddress,
      billingAddress: billingAddress,
    };
    try {
      const res: any = await UserHttp.createAccount(data, user?.userId);
      if (res.status === 200 && res.data.data) {
        customer.accounts.push(res.data.data);
        setCustomer(customer);
        toast.success('Account Added Successfully');
      } else {
        toast.error(res.data.errors[0].title);
      }
    } catch (e: any) {
      toast.error('Something went wrong');
    }
  };

  const closeModalFunc = () => {
    setOpenModal(false);
  };
  const openModalFunc = () => {
    setOpenModal(true);
  };

  const onHandleSideModal = (value) => {
    setIsShow(value);
  };

  return (
    <>
      {isShow ? (
        <CreateSubAccount handleModal={onHandleSideModal} isShow={isShow} />
      ) : null}

      <Card>
        <Card.Body className='p-md-5 p-sm-2 pb-0'>
          <div>
            <Card.Title>Account Details</Card.Title>
            <Accordion className='mt-4' defaultActiveKey='0'>
              {/* {customer.customerCategory === 'REGISTERED' &&
                customer?.accounts.map((account: any, index: number) => (
                  <Accordion.Item eventKey={index.toString()}>
                    <Accordion.Header>
                      {account?.kyc?.gstin?.value || account?.accountId}{' '}
                      {account.isPrimary ? (
                        <span className='badge bg-dark mx-3'>Primary</span>
                      ) : (
                        ''
                      )}
                    </Accordion.Header>
                    <Accordion.Body>
                      <Row>
                        <Col md={6}>
                          <Form.Group className='mb-3' controlId='gstin'>
                            <Form.Label>GSTIN</Form.Label>
                            <Form.Control
                              disabled
                              type='text'
                              value={account?.kyc?.gstin?.value || 'NA'}
                            />
                          </Form.Group>
                        </Col>

                        {/* <Col md={12}>
                          <Form.Group className='mb-3' controlId='address01'>
                            <Form.Label>Address</Form.Label>
                            <Form.Control
                              disabled
                              type='text'
                              value={
                                (account?.billingAddress?.address1 || '') +
                                (account?.billingAddress?.address2 || '')
                              }
                            />
                          </Form.Group>
                        </Col>

                        <Col md={6}>
                          <Form.Group className='mb-3' controlId='pin'>
                            <Form.Label>PIN Code</Form.Label>
                            <Form.Control
                              disabled
                              type='text'
                              value={account?.billingAddress?.pinCode || ''}
                            />
                          </Form.Group>
                        </Col>
                        <Col md={6}>
                          <Form.Group className='mb-3' controlId='state'>
                            <Form.Label>State</Form.Label>
                            <Form.Control
                              disabled
                              type='text'
                              value={account?.billingAddress?.state || ''}
                            />
                          </Form.Group>
                        </Col> */}
              {/* </Row>
                      </Accordion.Body>
                      </Accordion.Item> */}
              {/* ))} */}
              {(customer.customerCategory === 'UNREGISTERED' ||
                customer.customerCategory === 'REGISTERED') &&
                customer?.accounts.map((account: any, index: number) => (
                 <Accordion.Item key={account?.accountId || index} eventKey={index.toString()}>
                    <Accordion.Header>
                      {account?.accountId || ''}{' '}
                      {account.isPrimary ? (
                        <span className='badge bg-dark mx-3'>Primary</span>
                      ) : (
                        ''
                      )}
                    </Accordion.Header>
                    <Accordion.Body>
                      {editAddress ? (
                        <Form>
                          <Form.Group
                            className='mb-2'
                            controlId='formBasicAddressLine'
                          >
                            <Form.Label>Address Line</Form.Label>
                            <Form.Control
                              type='text'
                              placeholder='AddressLine'
                            />
                          </Form.Group>
                          <Form.Group
                            className='mb-2'
                            controlId='formBasicAddressLine2'
                          >
                            <Form.Label>Address Line 2</Form.Label>
                            <Form.Control
                              disabled
                              as='textarea'
                              rows={3}
                              value={
                                (account?.billingAddress?.address1 || '') +
                                (account?.billingAddress?.address2 || '')
                              }
                            />
                          </Form.Group>
                          <Row>
                            <Col xs={12} md={4}>
                              <Form.Group
                                className='mb-3'
                                controlId='formBasicState'
                              >
                                <Form.Label>State</Form.Label>
                                <Form.Control type='text' placeholder='State' />
                              </Form.Group>
                            </Col>
                            <Col xs={12} md={4}>
                              <Form.Group
                                className='mb-3'
                                controlId='formBasicCity'
                              >
                                <Form.Label>City</Form.Label>
                                <Form.Control type='text' placeholder='City' />
                              </Form.Group>
                            </Col>
                            <Col xs={12} md={4}>
                              <Form.Group
                                className='mb-3'
                                controlId='formBasicPincode'
                              >
                                <Form.Label>Pincode</Form.Label>
                                <Form.Control
                                  type='text'
                                  placeholder='Pincode'
                                />
                              </Form.Group>
                            </Col>
                          </Row>

                          <Row>
                            <div className='d-flex justify-content-end'>
                              <Button
                                variant='primary'
                                onClick={() => {
                                  setEditAddress(false);
                                }}
                              >
                                Update
                              </Button>
                            </div>
                          </Row>
                        </Form>
                      ) : (
                        <>
                          <Row>
                            {/* <Col md={12}>
                            <div className='d-flex justify-content-end'>
                              <Button
                                onClick={() => {
                                  setEditAddress(true);
                                }}
                              >
                                <i className='fas fa-edit'></i> Edit Address
                              </Button>
                            </div>
                          </Col> */}
                            {/* <Col md={12}>
                            <Form.Group className='mb-3' controlId='gstin'>
                              <Form.Label>Display Name</Form.Label>
                              <Form.Control
                                disabled
                                type='text'
                                value={account?.displayName || ''}
                              />
                            </Form.Group>
                          </Col>

                          <Col md={12}>
                            <Form.Group className='mb-3' controlId='address01'>
                              <Form.Label>Addresssss</Form.Label>
                              <Form.Control
                                disabled
                                as='textarea'
                                rows={3}
                                value={
                                  (account?.billingAddress?.address1 || '') +
                                  (account?.billingAddress?.address2 || '')
                                }
                              />
                            </Form.Group>
                          </Col> */}
                            <>
                              {customer.customerCategory === 'REGISTERED' && (
                                <Row>
                                  <Col md={12}>
                                    <Form.Group
                                      className='mb-3'
                                      controlId='gstin'
                                    >
                                      <Form.Label>GSTIN</Form.Label>
                                      <Form.Control
                                        disabled
                                        type='text'
                                        value={
                                          account?.kyc?.gstin?.value || 'NA'
                                        }
                                      />
                                    </Form.Group>
                                  </Col>
                                </Row>
                              )}
                            </>
                            <Col md={6}>
                              {/* <Card> */}
                              {/* <Card style={{ width: '20rem' }}> */}
                              <Card.Body>
                                <div>
                                  <Card.Title>Billing Address</Card.Title>
                                </div>
                                <Form.Group className='mb-3' controlId='gstin'>
                                  <Form.Label>Display Name</Form.Label>
                                  <br></br>
                                  <Form.Control
                                    disabled
                                    as='textarea'
                                    style={{ resize: 'none' }}
                                    value={account?.displayName || ''}
                                  />
                                  {/* <Form.Text>
                                    {account?.displayName || ''}
                                  </Form.Text> */}
                                </Form.Group>
                                <Form.Group
                                  className='mb-3'
                                  controlId='address01'
                                >
                                  <Form.Label>Address</Form.Label>
                                  <br></br>
                                  <Form.Control
                                    disabled
                                    as='textarea'
                                    style={{ resize: 'none' }}
                                    rows={7}
                                    value={
                                      (account?.billingAddress?.address1 ||
                                        '') +
                                      (account?.billingAddress?.address2 || '')
                                    }
                                  />
                                  {/* <Form.Text style={{ height: '100px' }}>
                                    {(account?.billingAddress?.address1 || '') +
                                      (account?.billingAddress?.address2 || '')}
                                  </Form.Text> */}
                                </Form.Group>
                                <Row>
                                  <Col md={6}>
                                    <Form.Group
                                      className='mb-3'
                                      controlId='pin'
                                    >
                                      <Form.Label>PIN Code</Form.Label>
                                      <br></br>
                                      <Form.Control
                                        disabled
                                        type='text'
                                        value={
                                          customer?.kyc?.aadhaar?.value &&
                                          account?.billingAddress?.pinCode
                                            ? account?.billingAddress?.pinCode
                                            : ''
                                        }
                                      />
                                      {/* <Form.Text>
                                        {account?.billingAddress?.pinCode || ''}
                                      </Form.Text> */}
                                    </Form.Group>
                                  </Col>
                                  <Col md={6}>
                                    <Form.Group
                                      className='mb-3'
                                      controlId='state'
                                    >
                                      <Form.Label>State</Form.Label>
                                      <br></br>
                                      <Form.Control
                                        disabled
                                        type='text'
                                        value={
                                          customer?.kyc?.aadhaar?.value &&
                                          account?.billingAddress?.state
                                            ? account?.billingAddress?.state
                                            : ''
                                        }
                                      />
                                      {/* <Form.Text>
                                        {account?.billingAddress?.state || ''}
                                      </Form.Text> */}
                                    </Form.Group>
                                  </Col>
                                </Row>
                              </Card.Body>
                              {/* </Card> */}
                            </Col>

                            <Col
                              md={6}
                              style={{ borderLeft: '1px solid black' }}
                            >
                              {/* <Card style={{ width: '20rem' }}> */}
                              {/* <Card> */}
                              <Card.Body>
                                <div className='d-flex justify-content-between'>
                                  <Card.Title>Shipping Address</Card.Title>
                                  {/* <Form.Label>Address</Form.Label> */}
                                  {/* <span className='fw-bold'>Edit</span> */}
                                  <button
                                    className='btn  btn-primary btn-sm '
                                    style={{
                                      borderRadius: '5px',
                                    }}
                                    onClick={() => openModalFunc()}
                                  >
                                    <span> Edit</span>
                                    {/* <svg
                                        stroke='currentColor'
                                        fill='currentColor'
                                        stroke-width='0'
                                        viewBox='0 0 24 24'
                                        height='1em'
                                        width='1em'
                                        xmlns='http://www.w3.org/2000/svg'
                                      >
                                        <path
                                          fill='none'
                                          stroke='#000'
                                          stroke-width='2'
                                          d='M14,4 L20,10 L14,4 Z M22.2942268,5.29422684 C22.6840146,5.68401459 22.6812861,6.3187139 22.2864907,6.71350932 L9,20 L2,22 L4,15 L17.2864907,1.71350932 C17.680551,1.319449 18.3127724,1.31277239 18.7057732,1.70577316 L22.2942268,5.29422684 Z M3,19 L5,21 M7,17 L15,9'
                                        ></path>
                                      </svg> */}
                                  </button>
                                </div>
                                <Form.Group className='mb-3' controlId='gstin'>
                                  <Form.Label>Display Name</Form.Label>
                                  <br></br>
                                  <Form.Control
                                    disabled
                                    as='textarea'
                                    style={{ resize: 'none' }}
                                    value={account?.displayName || ''}
                                  />
                                  {/* <Form.Text>
                                    {account?.displayName || ''}
                                  </Form.Text> */}
                                </Form.Group>
                                <Form.Group
                                  className='mb-3'
                                  controlId='address01'
                                >
                                  {/* <div className='d-flex'> */}
                                  <div className='d-flex justify-content-between'>
                                    <Form.Label>Address</Form.Label>
                                    <br></br>
                                    {/* <button
                                      className='btn btn-sm'
                                      onClick={() => openModalFunc()}
                                    >
                                      <svg
                                        stroke='currentColor'
                                        fill='currentColor'
                                        stroke-width='0'
                                        viewBox='0 0 24 24'
                                        height='1em'
                                        width='1em'
                                        xmlns='http://www.w3.org/2000/svg'
                                      >
                                        <path
                                          fill='none'
                                          stroke='#000'
                                          stroke-width='2'
                                          d='M14,4 L20,10 L14,4 Z M22.2942268,5.29422684 C22.6840146,5.68401459 22.6812861,6.3187139 22.2864907,6.71350932 L9,20 L2,22 L4,15 L17.2864907,1.71350932 C17.680551,1.319449 18.3127724,1.31277239 18.7057732,1.70577316 L22.2942268,5.29422684 Z M3,19 L5,21 M7,17 L15,9'
                                        ></path>
                                      </svg>
                                    </button> */}
                                  </div>
                                  {/* <div className=' justify-content-end'>
                                      <svg
                                        stroke='currentColor'
                                        fill='currentColor'
                                        stroke-width='0'
                                        viewBox='0 0 24 24'
                                        height='1em'
                                        width='1em'
                                        xmlns='http://www.w3.org/2000/svg'
                                      >
                                        <path
                                          fill='none'
                                          stroke='#000'
                                          stroke-width='2'
                                          d='M14,4 L20,10 L14,4 Z M22.2942268,5.29422684 C22.6840146,5.68401459 22.6812861,6.3187139 22.2864907,6.71350932 L9,20 L2,22 L4,15 L17.2864907,1.71350932 C17.680551,1.319449 18.3127724,1.31277239 18.7057732,1.70577316 L22.2942268,5.29422684 Z M3,19 L5,21 M7,17 L15,9'
                                        ></path>
                                      </svg>
                                    </div> */}
                                  <InputGroup>
                                    <Form.Control
                                      disabled
                                      as='textarea'
                                      style={{ resize: 'none' }}
                                      rows={7}
                                      value={
                                        (account?.shippingAddress?.address1 ||
                                          '') +
                                        ' ' +
                                        (account?.shippingAddress?.address2 ||
                                          '')
                                      }
                                    />
                                    {/* <Form.Text style={{ height: '100px' }}> */}
                                    {/* {account?.displayName || ''} */}
                                    {/* {(account?.shippingAddress?.address1 ||
                                        '') +
                                        ' ' +
                                        (account?.shippingAddress?.address2 ||
                                          '')} */}
                                    {/* </Form.Text> */}

                                    {/* <InputGroup.Text className='d-flex align-items-start p-2'>
                                      <button onClick={() => openModalFunc()}>
                                        <svg
                                          stroke='currentColor'
                                          fill='currentColor'
                                          stroke-width='0'
                                          viewBox='0 0 24 24'
                                          height='1em'
                                          width='1em'
                                          xmlns='http://www.w3.org/2000/svg'
                                        >
                                          <path
                                            fill='none'
                                            stroke='#000'
                                            stroke-width='2'
                                            d='M14,4 L20,10 L14,4 Z M22.2942268,5.29422684 C22.6840146,5.68401459 22.6812861,6.3187139 22.2864907,6.71350932 L9,20 L2,22 L4,15 L17.2864907,1.71350932 C17.680551,1.319449 18.3127724,1.31277239 18.7057732,1.70577316 L22.2942268,5.29422684 Z M3,19 L5,21 M7,17 L15,9'
                                          ></path>
                                        </svg>
                                      </button>
                                    </InputGroup.Text> */}
                                  </InputGroup>
                                </Form.Group>
                                <Row>
                                  <Col md={6}>
                                    <Form.Group
                                      className='mb-3'
                                      controlId='pin'
                                    >
                                      <Form.Label>PIN Code</Form.Label>
                                      <br></br>
                                      <Form.Control
                                        disabled
                                        type='text'
                                        value={
                                          customer?.kyc?.aadhaar?.value &&
                                          account?.shippingAddress?.pinCode
                                            ? account?.shippingAddress?.pinCode
                                            : ''
                                        }
                                      />
                                      {/* <Form.Text>
                                        {account?.shippingAddress?.pinCode ||
                                          ''}
                                      </Form.Text> */}
                                    </Form.Group>
                                  </Col>
                                  <Col md={6}>
                                    <Form.Group
                                      className='mb-3'
                                      controlId='state'
                                    >
                                      <Form.Label>State</Form.Label>
                                      <br></br>
                                      <Form.Control
                                        disabled
                                        type='text'
                                        value={
                                          customer?.kyc?.aadhaar?.value &&
                                          account?.shippingAddress?.state
                                            ? account?.shippingAddress?.state
                                            : ''
                                        }
                                      />
                                      {/* <Form.Text>
                                        {account?.shippingAddress?.state || ''}
                                      </Form.Text> */}
                                    </Form.Group>
                                  </Col>
                                </Row>
                              </Card.Body>
                              {/* </Card> */}
                            </Col>
                            {/* <Col md={6}>
                            <Form.Group className='mb-3' controlId='pin'>
                              <Form.Label>PIN Code</Form.Label>
                              <Form.Control
                                disabled
                                type='text'
                                value={account?.billingAddress?.pinCode || ''}
                              />
                            </Form.Group>
                          </Col>
                          <Col md={6}>
                            <Form.Group className='mb-3' controlId='state'>
                              <Form.Label>State</Form.Label>
                              <Form.Control
                                disabled
                                type='text'
                                value={account?.billingAddress?.state || ''}
                              />
                            </Form.Group>
                          </Col> */}
                          </Row>
                          {/* <hr></hr> */}
                        </>
                      )}
                    </Accordion.Body>
                  </Accordion.Item>
                ))}
            </Accordion>
          </div>
        </Card.Body>
        {/* <div className="mt-3 d-flex justify-content-end px-5 py-4">
          {(customer.customerCategory !== 'UNREGISTERED' || customer.customerType === 'IND' || customer?.accounts.length === 0) ? (
            <div className="bg-light">
              <Button variant="primary" className=""  onClick={() => onHandleSideModal(true)}>
                Create New Account
              </Button>
            </div>
          ) : ('')}
        </div> */}
      </Card>
      <Modal
        id='addAccountModal'
        isOpen={isOpen}
        onRequestClose={closeModal}
        contentLabel='Example Modal'
        style={styled}
      >
        <button
          className='btn modal-close absolute top-0 right-0 cursor-pointer flex flex-col items-center float-end text-white text-sm z-50'
          onClick={closeModal}
        >
          <svg
            className='fill-current text-black'
            xmlns='http://www.w3.org/2000/svg'
            width='18'
            height='18'
            viewBox='0 0 18 18'
          >
            <path d='M14.53 4.53l-1.06-1.06L9 7.94 4.53 3.47 3.47 4.53 7.94 9l-4.47 4.47 1.06 1.06L9 10.06l4.47 4.47 1.06-1.06L10.06 9z' />
          </svg>
        </button>
        <h2>Create New Account</h2>
        <div className='col-12'>
          <Row>
            <Col md={6}>
              <Form.Group className='mb-3' controlId='name'>
                <Form.Label>Display Name</Form.Label>
                <Form.Control
                  type='text'
                  value={accountDetails?.displayName || ''}
                  onChange={(event) =>
                    setAccount({
                      ...accountDetails,
                      displayName: event.target.value,
                    })
                  }
                />
              </Form.Group>
            </Col>
            <Col md={6}>
              <Form.Group className='mb-3' controlId='gstin'>
                <Form.Label>GSTIN</Form.Label>
                <Form.Control
                  type='text'
                  value={accountDetails?.kyc?.gstin?.value || ''}
                  onChange={(event) =>
                    setAccount({
                      ...accountDetails,
                      kyc: {
                        gstin: {
                          value: event.target.value,
                        },
                      },
                    })
                  }
                />
              </Form.Group>
            </Col>
            <Col md={12}>
              <h5>Billing Address</h5>
            </Col>
            <Col md={12}>
              <Form.Group className='mb-3' controlId='address01'>
                <Form.Label>Address Line 01</Form.Label>
                <Form.Control
                  type='text'
                  value={billingAddress?.address1 || ''}
                  onChange={(event) =>
                    setBillingAddress({
                      ...billingAddress,
                      address1: event.target.value,
                    })
                  }
                />
              </Form.Group>
            </Col>
            <Col md={12}>
              <Form.Group className='mb-3' controlId='address02'>
                <Form.Label>Address Line 02</Form.Label>
                <Form.Control
                  type='text'
                  value={billingAddress?.address2 || ''}
                  onChange={(event) =>
                    setBillingAddress({
                      ...billingAddress,
                      address2: event.target.value,
                    })
                  }
                />
              </Form.Group>
            </Col>
            <Col md={4}>
              <Form.Group className='mb-3' controlId='pin'>
                <Form.Label>PIN Code</Form.Label>
                <Form.Control
                  type='text'
                  value={billingAddress?.pinCode || ''}
                  onChange={(event) =>
                    setBillingAddress({
                      ...billingAddress,
                      pinCode: event.target.value,
                    })
                  }
                />
              </Form.Group>
            </Col>
            <Col md={4}>
              <Form.Group className='mb-3' controlId='city'>
                <Form.Label>City</Form.Label>
                <Form.Control
                  type='text'
                  value={billingAddress?.city || ''}
                  onChange={(event) =>
                    setBillingAddress({
                      ...billingAddress,
                      city: event.target.value,
                    })
                  }
                />
              </Form.Group>
            </Col>
            <Col md={4}>
              <Form.Group className='mb-3' controlId='state'>
                <Form.Label>State</Form.Label>
                <Form.Control
                  type='text'
                  value={billingAddress?.state || ''}
                  onChange={(event) =>
                    setBillingAddress({
                      ...billingAddress,
                      state: event.target.value,
                    })
                  }
                />
              </Form.Group>
            </Col>
            <Col md={12}>
              <h5>Shipping Address</h5>
            </Col>
            <Col md={12}>
              <Form.Group className='mb-3' controlId='address01'>
                <Form.Label>Address Line 01</Form.Label>
                <Form.Control
                  type='text'
                  value={shippingAddress?.address1 || ''}
                  onChange={(event) =>
                    setShippingAddress({
                      ...shippingAddress,
                      address1: event.target.value,
                    })
                  }
                />
              </Form.Group>
            </Col>
            <Col md={12}>
              <Form.Group className='mb-3' controlId='address02'>
                <Form.Label>Address Line 02</Form.Label>
                <Form.Control
                  type='text'
                  value={shippingAddress?.address2 || ''}
                  onChange={(event) =>
                    setShippingAddress({
                      ...shippingAddress,
                      address2: event.target.value,
                    })
                  }
                />
              </Form.Group>
            </Col>
            <Col md={4}>
              <Form.Group className='mb-3' controlId='pin'>
                <Form.Label>PIN Code</Form.Label>
                <Form.Control
                  type='text'
                  value={shippingAddress?.pinCode || ''}
                  onChange={(event) =>
                    setShippingAddress({
                      ...shippingAddress,
                      pinCode: event.target.value,
                    })
                  }
                />
              </Form.Group>
            </Col>
            <Col md={4}>
              <Form.Group className='mb-3' controlId='city'>
                <Form.Label>City</Form.Label>
                <Form.Control
                  type='text'
                  value={shippingAddress?.city || ''}
                  onChange={(event) =>
                    setShippingAddress({
                      ...shippingAddress,
                      city: event.target.value,
                    })
                  }
                />
              </Form.Group>
            </Col>
            <Col md={4}>
              <Form.Group className='mb-3' controlId='state'>
                <Form.Label>State</Form.Label>
                <Form.Control
                  type='text'
                  value={shippingAddress?.state || ''}
                  onChange={(event) =>
                    setShippingAddress({
                      ...shippingAddress,
                      state: event.target.value,
                    })
                  }
                />
              </Form.Group>
            </Col>
            <Col md={12}>
              <Button variant='primary' className='float-end mw' onClick={save}>
                Save
              </Button>
            </Col>
          </Row>
        </div>
      </Modal>
      <UpdateNewAddress
        onCloseModal={closeModalFunc}
        OpenModal={OpenModal}
        accountId={customer?.accounts[0]?.accountId}
        customerId={customer?.customerId}
        customer={customer}
        setCustomer={setCustomer}
        shippingAddress={customer?.accounts[0]?.shippingAddress}
      />
      {/* <Modal show={true} onHide={closeModalFunc} animation={false}>
        <Modal.Header closeButton>
          <Modal.Title>Modal heading</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group className='mb-2' controlId='formBasicAddressLine'>
              <Form.Label>Address Line</Form.Label>
              <Form.Control type='text' placeholder='AddressLine' />
            </Form.Group>
            <Form.Group className='mb-2' controlId='formBasicAddressLine2'>
              <Form.Label>Address Line 2</Form.Label>
              <Form.Control disabled as='textarea' rows={3} />
            </Form.Group>
            <Row>
              <Col xs={12} md={4}>
                <Form.Group className='mb-3' controlId='formBasicState'>
                  <Form.Label>State</Form.Label>
                  <Form.Control type='text' placeholder='State' />
                </Form.Group>
              </Col>
              <Col xs={12} md={4}>
                <Form.Group className='mb-3' controlId='formBasicCity'>
                  <Form.Label>City</Form.Label>
                  <Form.Control type='text' placeholder='City' />
                </Form.Group>
              </Col>
              <Col xs={12} md={4}>
                <Form.Group className='mb-3' controlId='formBasicPincode'>
                  <Form.Label>Pincode</Form.Label>
                  <Form.Control type='text' placeholder='Pincode' />
                </Form.Group>
              </Col>
            </Row>

            <Row>
              <div className='d-flex justify-content-end'>
                <Button
                  variant='primary'
                  onClick={() => {
                    setEditAddress(false);
                  }}
                >
                  Update
                </Button>
              </div>
            </Row>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant='secondary' onClick={closeModalFunc}>
            Close
          </Button>
          <Button variant='primary' onClick={closeModalFunc}>
            Save Changes
          </Button>
        </Modal.Footer>
      </Modal> */}
      {/* <Modal
        id='addAccountModal'
        isOpen={OpenModal}
        onRequestClose={closeModal}
        contentLabel='Example Modal'
        style={styled}
      >
        <button
          className='btn modal-close absolute top-0 right-0 cursor-pointer flex flex-col items-center float-end text-white text-sm z-50'
          onClick={closeModal}
        >
          <svg
            className='fill-current text-black'
            xmlns='http://www.w3.org/2000/svg'
            width='18'
            height='18'
            viewBox='0 0 13 18'
          >
            <path d='M14.53 4.53l-1.06-1.06L9 7.94 4.53 3.47 3.47 4.53 7.94 9l-4.47 4.47 1.06 1.06L9 10.06l4.47 4.47 1.06-1.06L10.06 9z' />
          </svg>
        </button>
        <h2>Update Address</h2>
        <Form>
          <Form.Group className='mb-2' controlId='formBasicAddressLine'>
            <Form.Label>Address Line</Form.Label>
            <Form.Control type='text' placeholder='AddressLine' />
          </Form.Group>
          <Form.Group className='mb-2' controlId='formBasicAddressLine2'>
            <Form.Label>Address Line 2</Form.Label>
            <Form.Control disabled as='textarea' rows={3} />
          </Form.Group>
          <Row>
            <Col xs={12} md={4}>
              <Form.Group className='mb-3' controlId='formBasicState'>
                <Form.Label>State</Form.Label>
                <Form.Control type='text' placeholder='State' />
              </Form.Group>
            </Col>
            <Col xs={12} md={4}>
              <Form.Group className='mb-3' controlId='formBasicCity'>
                <Form.Label>City</Form.Label>
                <Form.Control type='text' placeholder='City' />
              </Form.Group>
            </Col>
            <Col xs={12} md={4}>
              <Form.Group className='mb-3' controlId='formBasicPincode'>
                <Form.Label>Pincode</Form.Label>
                <Form.Control type='text' placeholder='Pincode' />
              </Form.Group>
            </Col>
          </Row>

          <Row>
            <div className='d-flex justify-content-end'>
              <Button
                variant='primary'
                onClick={() => {
                  setEditAddress(false);
                }}
              >
                Update
              </Button>
            </div>
          </Row>
        </Form>
      </Modal> */}
    </>
  );
};

export default NewAccountDetails;
